module.exports = __webpack_public_path__ + "static/media/traffic-road.9ccfeaa8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/citylink/traffic-road.svg
// module id = 703
// module chunks = 0